export default "__VITE_ASSET__BjbEGpHK__"